import { lazy } from "react";
import { Navigate } from "react-router-dom";
import Loadable from "../Loadable";

const routeBilling = (props) => [
    {
        element: <Navigate to="/nuvei-billing/inicio" replace />,
    },
    { path: "inicio", element: <Home /> },

];


const Home = Loadable(lazy(() => import("../../pages/billing-data/Home")));


export { Loadable };

export default routeBilling;
